import Table from 'semantic-ui-react/dist/commonjs/collections/Table';
import '@purple/semantic-ui-purple-theme/components/table.css';

export default Table;
